"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveContact = void 0;
/**
 * Save contact in storage
 *
 * @alpha
 * @typeParam T The type of the repository that should be derived from {@link IContactRepository}
 * @param repository The repository instance to handle contacts. See {@link contactRepository}
 * @param contact A contact to store
 *
 * @example
 * ```ts
 * saveContact(contactRepository, contact);
 * ```
 */
function saveContact(repository, contact) {
    repository.saveContact(contact);
}
exports.saveContact = saveContact;
//# sourceMappingURL=save-contact.js.map